/* Ritual Casa — interacciones. Cada init comprueba si su elemento existe. */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.rc-reveal:not(.rc-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rc-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria(raiz) {
    var principal = raiz.querySelector('[data-rc-principal]');
    if (!principal) return;
    raiz.querySelectorAll('[data-rc-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 180);
        raiz.querySelectorAll('[data-rc-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
        btn.classList.add('is-activa');
      });
    });
  }

  function dinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComa = entero + ',' + partes[1];
    if (!formato) return conComa + ' €';
    return formato.replace(/\{\{\s*\w+\s*\}\}/, conComa);
  }

  function initProducto(raiz) {
    var datos = raiz.querySelector('[data-rc-variantes]');
    var form = raiz.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var inputId = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-rc-anadir]');
    var precio = raiz.querySelector('[data-rc-precio]');
    var tachado = raiz.querySelector('[data-rc-tachado]');
    var formato = raiz.getAttribute('data-formato');
    var textoBoton = boton ? boton.getAttribute('data-texto') : '';
    var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
    var variantes = datos ? JSON.parse(datos.textContent) : [];

    function actualizar() {
      if (!variantes.length) return;
      var elegidas = [];
      raiz.querySelectorAll('[data-rc-opcion]').forEach(function (fs) {
        var marcado = fs.querySelector('input:checked');
        elegidas.push(marcado ? marcado.value : null);
      });
      var v = variantes.find(function (x) {
        return x.options.every(function (o, i) { return o === elegidas[i]; });
      });
      if (!v) {
        if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
        return;
      }
      inputId.value = v.id;
      if (precio) precio.textContent = dinero(v.price, formato);
      if (tachado) {
        if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price, formato); tachado.hidden = false; }
        else { tachado.hidden = true; }
      }
      if (boton) {
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
      }
      if (v.featured_media && v.featured_media.preview_image) {
        var mini = raiz.querySelector('[data-rc-mini][data-media-id="' + v.featured_media.id + '"]');
        if (mini) mini.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    raiz.querySelectorAll('[data-rc-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

    // Cantidad
    var cant = raiz.querySelector('.rc-cantidad input');
    raiz.querySelectorAll('[data-rc-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(cant.value || '1', 10) + parseInt(b.getAttribute('data-rc-cant'), 10);
        cant.value = Math.max(1, n);
      });
    });

    // Selector de packs: fija la cantidad (2 o 3 unidades del mismo producto) y muestra el precio del pack
    raiz.querySelectorAll('[data-rc-packs] input').forEach(function (p) {
      p.addEventListener('change', function () {
        if (cant) cant.value = p.value;
        if (precio && p.getAttribute('data-precio')) precio.textContent = p.getAttribute('data-precio');
      });
    });

    // Añadir al carrito sin salir de la página (con respaldo al envío normal)
    var error = raiz.querySelector('.rc-pdp__error');
    form.addEventListener('submit', function (ev) {
      if (!window.fetch) return;
      ev.preventDefault();
      if (boton) { boton.disabled = true; boton.setAttribute('aria-busy', 'true'); }
      if (error) error.textContent = '';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (e) {
          if (error) error.textContent = e.message;
          if (boton) { boton.disabled = false; boton.removeAttribute('aria-busy'); }
        });
    });

    // Barra fija en móvil
    var barra = document.querySelector('[data-rc-barra]');
    if (barra && boton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        barra.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(boton);
      var bb = barra.querySelector('button');
      if (bb) bb.addEventListener('click', function () { boton.click(); });
    }
  }

  function init() {
    initReveal();
    document.querySelectorAll('[data-rc-producto]').forEach(function (r) { initGaleria(r); initProducto(r); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
